import React, { useContext, useEffect } from "react";
import { clBasic } from "./general";
import { AppContext } from "./index";

export default function GraficoLog({ tipo, prioridad, categoria, estado, persona, w, h, setPlazo }) {
  let { firebase } = useContext(AppContext);
  let color = ["#40FF00", "#FE9A2E", "#5858FA", "#04B431", "#F7FE2E"];
  let { titulo, suma, cantidad, listaValores, listaEtiquetas } = firebase.datosGraficoLog(
    tipo,
    prioridad,
    categoria,
    estado,
    persona
  );
  let coordVals = []; // se cargara con las coordenadas de las etiquetas

  const Scanvas = {
    position: "relative",
    height: `${h}px`,
    //   background: "linear-gradient(to top, #212121 0%, #424242 100%)",
  };

  useEffect(() => {
    let ctx = document.getElementById("pieMnt").getContext("2d");
    pie(ctx);
  });

  function pie(c) {
    h = h * 0.933; // para contemplar el ancho de los tabs y lograr igualar el cuadro de incidencias
    const radio = (h * 6.5) / 22;
    const xcenter = w / 2;
    const ycenter = h / 1.8;
    let ang = 0;
    let x1 = 0;
    let y1 = 0;
    let x2 = 0;
    let y2 = 0;
    let alfa = 0;

    // titulo
    c.clearRect(0, 0, w, h);
    c.beginPath();
    c.lineWidth = 1;
    c.font = "900 3vh Arial";
    c.fillStyle = clBasic
    c.fillText(titulo, xcenter - c.measureText(titulo).width / 2, 30);

    //  c.stroke();

    // pie
    for (let x = 0; x < cantidad; x++) {
      c.beginPath();
      c.moveTo(xcenter, ycenter);
      c.arc(xcenter, ycenter, radio, ang, ang + (listaValores[x] * 2 * Math.PI) / suma);
      c.fillStyle = color[x];
      c.fill();
      alfa = ang + (listaValores[x] * 2 * Math.PI) / suma / 2;
      ang = ang + (listaValores[x] * 2 * Math.PI) / suma;
      // cargar vector con coordenadas para etiquetas en el grafico
      x1 = (radio * Math.cos(alfa)) / 2;
      y1 = (radio * Math.sin(alfa)) / 2;
      x2 = xcenter + radio * 1.1 * Math.cos(alfa);
      y2 = ycenter + radio * 1.1 * Math.sin(alfa);
      coordVals.push({ x1: x1, y1: y1, x2: x2, y2: y2 });
    }
    // etiquetas con valores en el grafico

    c.lineWidth = 1;
    c.font = "2.4vh Arial";
    for (let x = 0; x < coordVals.length; x++) {
      if (listaValores[x] !== 0) {
        // lineas y etiquetas
        c.beginPath();
        c.fillStyle = clBasic
        c.font = "2.2vh Arial";
        c.moveTo(xcenter + 2 * coordVals[x].x1, ycenter + 2 * coordVals[x].y1);
        c.lineTo(coordVals[x].x2, coordVals[x].y2);
        c.lineTo(coordVals[x].x1 > 0 ? coordVals[x].x2 + 110 : coordVals[x].x2 - 110, coordVals[x].y2);

        let xinicio = coordVals[x].x1 > 0 ? coordVals[x].x2 + 110 - c.measureText(listaEtiquetas[x]).width : coordVals[x].x2 - 110;
        c.fillText(listaEtiquetas[x], xinicio, coordVals[x].y2 - 3);
        c.stroke();
        // numeros interior
        c.fillStyle = "#212121";
        c.font = "800 2.7vh Arial";
        c.fillText(listaValores[x], xcenter + coordVals[x].x1, ycenter + coordVals[x].y1);
      }
    }
  }

  function etiqueta(x, y) {
    // devuelve la posicion del vector correspondiente a la etiqueta segun coord  del mouse
    for (let i = 0; i < coordVals.length; i++) {
      if (coordVals[i].x1 > 0) {
        if (coordVals[i].x2 - 5 < x && x < coordVals[i].x2 + 105 && coordVals[i].y2 - 20 < y && y < coordVals[i].y2 + 10) return i;
      } else {
        if (coordVals[i].x2 + 5 > x && x > coordVals[i].x2 - 105 && coordVals[i].y2 - 20 < y && y < coordVals[i].y2 + 10) return i;
      }
    }
  }

  function setearPlazo(e) {
    let x = e.clientX - e.target.getClientRects()[0].left;
    let y = e.clientY - e.target.getClientRects()[0].top;

    switch (etiqueta(x, y)) {
      case 0:
        setPlazo(0);
        break;
      case 1:
        setPlazo(2);
        break;
      case 2:
        setPlazo(14);
        break;
      case 3:
        setPlazo(15);
        break;
      case 4:
        setPlazo(-1);
        break;
      default:
        break;
    }
  }

  function setPointer(e) {
    let x = e.clientX - e.target.getClientRects()[0].left;
    let y = e.clientY - e.target.getClientRects()[0].top;
    if (etiqueta(x, y) !== undefined) document.getElementById("pieMnt").style.cursor = "pointer";
    else document.getElementById("pieMnt").style.cursor = "";
  }

  return (
    <div style={Scanvas} onClick={(e) => setearPlazo(e)} onMouseMove={(e) => setPointer(e)}>
      <canvas id="pieMnt" height={h.toString() + "px"} width={w.toString() + "px"} />
    </div>
  );
}
